// extracted by mini-css-extract-plugin
module.exports = {"loadingPage":"loader_loadingPage__3gmnq","loadingPageContent":"loader_loadingPageContent__2eCtZ","loadingText":"loader_loadingText__30hfK"};